export const libraryItemTypes = {
    folder: "folder",
    image: "image",
    video: "video",
    document: "document",
    audio: "audio"
};
